<template>
    <div class="filter-grid">
        <div>
            <v-select :items="customerTypeItems" v-model="filter.is_company" label="Kundetype" hide-details/>
        </div>
        <div>
            <v-select :items="leasingItems" v-model="filter.car_is_leasing" label="Leasingkunde" hide-details/>
        </div>
        <div>
            <customer-category-select v-model="filter.category"/>
        </div>
        <div>
            <InvoiceYearSelect v-model="filter.invoice_year"></InvoiceYearSelect>
        </div>
        <div class="filter-grid-full hidden-print-only">
            <v-btn color="deep-orange" outlined class="ma-0 px-2" @click="filter.is_deleted = true"
                   v-if="!filter.is_deleted">
                Vis arkiv
            </v-btn>
            <v-btn color="primary" outlined class="ma-0 px-2" @click="filter.is_deleted = false"
                   v-if="filter.is_deleted">
                Vis aktive
            </v-btn>
        </div>
    </div>
</template>

<script>
    import {debounce} from 'lodash';
    import {cleanFilter, getCustomerTypeItems} from "../../../helpers";
    import CustomerCategorySelect from '../CustomerCategorySelect';
    import InvoiceYearSelect from "@/components/helpers/filter/InvoiceYearSelect";
    import * as moment from "moment";

    export default {
        components: {
            CustomerCategorySelect,
            InvoiceYearSelect
        },
        data() {
            return {
                filter: {
                    is_deleted: false,
                    is_company: null,
                    car_is_leasing: null,
                    category: null,
                    invoice_year: moment().year(),
                    ...cleanFilter(this.$route.query),
                    page: 1,
                }
            }
        },

        watch: {
            filter: {
                handler: debounce(function () {
                    this.$router.replace({query: cleanFilter(this.filter)});
                    this.$emit('filter', {...this.filter});
                }, 500),
                deep: true
            }
        },

        computed: {
            customerTypeItems() {
                return [
                    {value: null, text: 'Alle'},
                    ...getCustomerTypeItems()
                ]
            },

            leasingItems() {
                return [
                    {value: null, text: 'Alle'},
                    {value: true, text: 'Kun leasingkunder'},
                    {value: false, text: 'Ikke leasingkunder'}
                ]
            }
        }
    }
</script>

<style scoped>
    .filter-grid {
        display: grid;
        grid-gap: 1rem;
        grid-template-columns: minmax(auto, 155px) minmax(auto, 320px) repeat(auto-fill, minmax(auto, 155px));
    }

    .filter-grid-narrow .filter-grid-full {
        flex-basis: 100%;
    }

    @media print {
        .filter-grid-narrow > div, .filter-grid-narrow .filter-grid-full {
            flex-basis: 0;
            flex-grow: 1;
            padding-right: 0.5cm
        }
    }
</style>
